<template>
  <div class="">
    <sticky class="page-header sticky-page-header"
            :actions="actionButtons" :bigTotal="bigTotal"
            :loading="loading" :total="total"
            :label="'Groupe'">
    </sticky>
    <div class="columns collapseColumn collapseColumn--left collapseColumn--alignStart" id="columns-collapse"
         :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-12">
        <div class="is-border is-radius-large">
          <div class="column has-bg-light is-paddingless-top is-paddingless-bottom is-radius-top-left-large is-radius-top-right-large">
            <div class="columns is-gapless is-padding-left is-padding-right is-vcentered">
              <div class="column">
                <pagination :loading="loading" @ChangePage="currentPage = $event" :currentPage="currentPage"
                            :totalPage="totalPage" :reverse="true"></pagination>
              </div>
            </div>
          </div>
          <div class="is-border-top">
            <table v-show="!loading && items.length" class="table is-fullwidth is-marginless-bottom is-last-fixed-small">
              <thead>
              <tr class="is-size-6">
                <th>
                  <sortable @sort="sort('company_name', $event)" :sort="sortBy.last_name" label="Société"></sortable>
                </th>
                <th>Manager</th>
                <th>Collaborateurs</th>
                <th class="has-text-centered is-narrow">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="m in items" :key="m.pk" class="is-size-6">
                <td class="is-cell-hoverable">
                  <router-link :to="{name: 'CompanyVue', params: {id: m.company}}">{{m.company_name}}</router-link>
                </td>
                <td class="is-cell-hoverable">
                  <router-link :to="{name: 'UserVue', params: {id: m.pk}}">  {{m.first_name[0]}}. {{m.last_name}}</router-link>
                </td>
                <td>{{m.sellers.length}} collaborateurs</td>
                <td class="has-text-centered actions">
                  <display-button-list :forceDropDown="true" :buttons="buttonList" :data="m"></display-button-list>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-show="!loading && !items.length">
              <div class="columns">
                <div class="column">
                  <h2 class="title is-3 has-text-weight-bold">Aucun groupe disponible</h2>
                </div>
              </div>
            </div>
            <div class="columns is-gapless is-padding-left is-padding-right is-vcentered" v-if="!loading">
              <div class="column">
                <pagination :loading="loading" @ChangePage="currentPage = $event" :currentPage="currentPage"
                            :totalPage="totalPage" :reverse="true"></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {GenericList, Sort, Filter} from '../../mixins'
  export default {
    name: 'GroupList',
    props: {},
    data () {
      return {
        actionButtons: [
          {
            linkClass: ['button', 'is-white'],
            icon: ['fa-sync'],
            action: () => {
              this.loadItems()
            }
          }
        ],
        buttonList: [
          {
            routeName: 'UserVue',
            icon: 'fa-eye',
            text: 'Voir'
          },
          {
            routeName: 'UserTeam',
            icon: 'fal fa-users',
            text: 'Gestion du groupe'
          },
          {
            routeName: 'UserEdit',
            icon: 'fa-edit',
            text: 'Éditer'
          }
        ],
        query: {profil_type: ['manager_ext', 'manager']},
        service: this.$api.userService,
        loadDocuments: this.loadItems
      }
    },
    mixins: [GenericList, Sort, Filter],
    methods: {
      goToCompanyView (companyPk, event) {
        this.$router.push({name: 'CompanyVue', params: {id: companyPk}})
      },
      goToManagerView (manager, event) {
        this.$router.push({name: 'UserVue', params: {id: manager.pk}})
      }
    },
    created () {
      this.loadItems()
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/group/GroupList.vue